import { api } from "./api";

export async function getDashboardOverview() {
  const r = await api.get("/dashboard/overview");
  return r.data;
}

export async function refreshDashboard() {
  const r = await api.post("/dashboard/refresh");
  return r.data;
}

export async function getDashboardActivity(limit = 100) {
  const r = await api.get(`/dashboard/activity?limit=${limit}`);
  return r.data.items || [];
}
